/* eslint-disable no-shadow */

export enum Palette {
  Gray100 = '#FFFFFF',
  Gray200 = '#FAFAFA',
  Gray300 = '#F5F5F5',
  Gray400 = '#F0F0F0',
  Gray500 = '#D9D9D9',
  Gray600 = '#BFBFBF',
  Gray700 = '#8C8C8C',
  Gray800 = '#595959',
  Gray900 = '#262626',
  Gray1000 = '#000000',
  DarkBlue100 = '#E6F7FF',
  DarkBlue200 = '#BAE7FF',
  DarkBlue300 = '#91D5FF',
  DarkBlue400 = '#69C0FF',
  DarkBlue500 = '#40A9FF',
  DarkBlue600 = '#1890FF',
  DarkBlue700 = '#096DD9',
  DarkBlue800 = '#0050B3',
  DarkBlue900 = '#003A8C',
  DarkBlue1000 = '#002766',

  Baron = '#612199',
  Herald = '#ec4ee4',
  Yellow = '#f0d223',
  SkyBlue = '#33dcff',
  Success = '#10dc7f',
  Danger = '#ec1919',

  Opacity10 = 'rgba(2,2,2,.1)',
  Opacity50 = 'rgba(2,2,2,.5)'
}
